<template>
  <svg
    id="Search-Circle--Streamline-Nova"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <desc>Search Circle Streamline Icon: https://streamlinehq.com</desc>
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M12 24c6.6274 0 12 -5.3726 12 -12 0 -6.62742 -5.3726 -12 -12 -12C5.37258 0 0 5.37258 0 12c0 6.6274 5.37258 12 12 12ZM11 7.5c-1.933 0 -3.5 1.567 -3.5 3.5s1.567 3.5 3.5 3.5 3.5 -1.567 3.5 -3.5 -1.567 -3.5 -3.5 -3.5ZM5.5 11c0 -3.03757 2.46243 -5.5 5.5 -5.5 3.0376 0 5.5 2.46243 5.5 5.5 0 1.1576 -0.3576 2.2316 -0.9684 3.1177l2.6752 2.6752 -1.4142 1.4142 -2.6753 -2.6752c-0.886 0.6106 -1.9599 0.9681 -3.1173 0.9681 -3.03757 0 -5.5 -2.4624 -5.5 -5.5Z"
      clip-rule="evenodd"
      stroke-width="1"
    />
  </svg>
</template>
